import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    quoteId: String
  }

  continueShopping(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'continue_shopping', {})
    }
  }

  beginCheckout(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'begin_checkout', {})
    }
  }

  submitQuote(event) {
    if (typeof gtag === 'function') {
      gtag('event', 'submit_quote_request', {
        quote_id: this.quoteIdValue
      })
    }
  }
}